import { __ } from '@wordpress/i18n';
import {
	formatCapitalize,
	formatItalic,
	formatLowercase,
	formatStrikethrough,
	formatUnderline,
	formatUppercase,
} from '@wordpress/icons';

import { BREAKPOINT_LABELS, COMMON_UNITS } from '../common';
import { FontFamilyOption } from './types';

/**
 * Re-export common constants for backward compatibility
 */
export const breakpointLabels = BREAKPOINT_LABELS;
export const TYPOGRAPHY_UNITS = COMMON_UNITS;

/**
 * Default enabled controls - all typography controls enabled by default
 */
export const DEFAULT_ENABLED_CONTROLS = {
	fontFamily: true,
	fontSize: true,
	fontWeight: true,
	fontStyle: true,
	textDecoration: true,
	textTransform: true,
	lineHeight: true,
	letterSpacing: true,
	wordSpacing: false, // Disabled by default
	color: true,
	textAlign: true,
	responsive: true, // Disabled by default
};

/**
 * Default font family options with common web-safe fonts
 */
export const DEFAULT_FONT_FAMILY_OPTIONS: FontFamilyOption[] = [
	{
		label: 'Default',
		value: '',
	},
];

/**
 * Font style options for typography control
 */
export const fontStyleOptions = [
	{
		label: __( 'Italic', 'redfox-thank-you' ),
		value: 'italic',
		icon: formatItalic,
	},
];

/**
 * Text decoration options for typography control
 */
export const textDecorationOptions = [
	{
		label: __( 'Underline', 'redfox-thank-you' ),
		value: 'underline',
		icon: formatUnderline,
	},
	{
		label: __( 'Strikethrough', 'redfox-thank-you' ),
		value: 'line-through',
		icon: formatStrikethrough,
	},
];

/**
 * Font weight options for typography control
 */
export const fontWeightOptions = [
	{ label: __( 'Light', 'redfox-thank-you' ), value: '300' },
	{ label: __( 'Normal', 'redfox-thank-you' ), value: '400' },
	{ label: __( 'Medium', 'redfox-thank-you' ), value: '500' },
	{ label: __( 'Semi Bold', 'redfox-thank-you' ), value: '600' },
	{ label: __( 'Bold', 'redfox-thank-you' ), value: '700' },
	{ label: __( 'Extra Bold', 'redfox-thank-you' ), value: '800' },
];

/**
 * Text transform options for typography control
 */
export const textTransformOptions = [
	{
		label: __( 'Uppercase', 'redfox-thank-you' ),
		value: 'uppercase',
		icon: formatUppercase,
	},
	{
		label: __( 'Lowercase', 'redfox-thank-you' ),
		value: 'lowercase',
		icon: formatLowercase,
	},
	{
		label: __( 'Capitalize', 'redfox-thank-you' ),
		value: 'capitalize',
		icon: formatCapitalize,
	},
];
